module.exports = __webpack_public_path__ + "img/shop01.9215a1ca.png";